module.exports = __webpack_public_path__ + "img/practiceEnd.a47a5ddb.png";